export enum EDateComponentType {
	DATE_LONG = 'dateLong',
	DATE_SHORT = 'dateShort',
}

export interface IDateComponentProps {
	value?: string;
	showLocalizedDate?: boolean;
	dateType?: EDateComponentType;
	timeStyle?: 'short' | 'full' | 'long' | 'medium' | null;
}
